
import {Component, Prop, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";

const userModule = namespace("userModule");

@Component({
    components: {}
})
export default class SummarySection extends Vue {

    @Prop() readonly title: string;
    @Prop() readonly values: any[];
    @Prop() readonly deleteButton: boolean;
    @Prop() readonly isComptageData: boolean;

    img(value) {
        return require('@/assets/' + value);
    }
}
